module.exports = __webpack_public_path__ + "cf27a898819e1fec79407a1157f1d2b3.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/178.png
// module id = 1764
// module chunks = 2